import { customAlphabet } from 'nanoid';
/**
 * Creates a random UUID with only alphanumeric characters.
 */
export const getUuid = customAlphabet('0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ', 7);
//# sourceMappingURL=get-uuid.js.map